/* eslint-disable prettier/prettier */
import DataGrid from '@cx/ui/components/DataGrid';
import { styled } from '@cx/ui';

function DataTable({
  className,
  columns,
  data,
  pagination,
  paginationOptions,
  sorting,
  sortingOptions,
  isTableResizable = true,
  ...props
}: {
  className?: string;
  columns: any[];
  data: any[];
  [key: string]: any;
  pagination: any;
  paginationOptions: any;
  sorting: any;
  sortingOptions: any;
  isTableResizable?: boolean;
}) {
  return (
    <div className={className}>
      <DataGrid
        columns={columns}
        data={data}
        pagination={pagination}
        paginationOptions={paginationOptions}
        sorting={sorting}
        isTableResizable={isTableResizable}
        sortingOptions={sortingOptions}
        {...props}
      />
    </div>
  );
}

export const CategoryStyledDataGrid = styled(DataTable)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
  borderCollapse: 'collapse',
  '& > div': {
    minHeight: 0,
    height: '100%',
    overflowY: 'auto',
  },
  th: {
    backgroundColor: '#cecece',
    padding: '8px 16px',
    fontSize: '12px',
  },
  tr: {
    backgroundColor: 'white',
    '&:nth-of-type(odd)': {
      backgroundColor: '#f1f1f1',
    },
    td: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '12px',
      padding: '7px 10px',
      borderLeft: '1px solid #d9d9d9',
      borderRight: '1px solid #d9d9d9',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&:first-of-type': {
        borderLeft: 'none',
      },
      '&:last-of-type': {
        borderRight: 'none',
      },
    },
  },
}));

export const SessionExplorerStyledDataGrid = styled(DataTable)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
  borderCollapse: 'collapse',
  '& > div': {
    minHeight: 0,
    height: '100%',
    overflowY: 'auto',
  },
  th: {
    padding: '20px',
    fontSize: '12px',
    textAlign: 'left',
  },
  tr: {
    width: '12.5%',
    backgroundColor: 'white',

    borderBottom: '1px solid #d9d9d9',
    '&:first-of-type': {
      borderTop: '1px solid #d9d9d9',
    },

    td: {
      padding: '20px',
    },

    '.data-grid-table > div:last-of-type': {
      paddingTop: '20px',
    },
  },
}));

export const DynamicTableStyledDataGrid = styled(DataTable)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
  borderCollapse: 'collapse',
  '& > div': {
    minHeight: 0,
    height: '100%',
    overflowY: 'auto',
  },
  th: {
    backgroundColor: '#cecece',
    padding: '8px 12px',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '12px',
  },
  tr: {
    td: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '12px',
      padding: '7px 10px',
      borderLeft: '1px solid #d9d9d9',
      borderRight: '1px solid #d9d9d9',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&:first-of-type': {
        borderLeft: 'none',
      },
      '&:last-of-type': {
        borderRight: 'none',
      },
    },
  },
}));

export const DataGridSkeletonStyled = styled(DataTable)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',
  '& > div': {
    minHeight: 0,
    height: '100%',
    overflowY: 'auto',
  },
}));
